export default "__VITE_ASSET__BiXF5cEt__"